export enum COLUMN_TYPES {
	ID = 'id',
	PRIORITY = 'priority',
	ASSET = 'asset',
	AVATAR = 'avatar',
	STATUS = 'status',
	DATE_RANGE = 'date_range',
	DATE = 'date',
	DATE_TIME = 'dateTime',
	DATE_AGO = 'dateAgo',
	LINKED_BTN = 'linkedBtn',
	GREY_TEXT = 'greyText',
	LINKED_LIST = 'linkedList',
	BODY_HEADING = 'bodyHeading',
	EXPANSION = 'expansion',
	NAME = 'name',
	ARRAY = 'array',
	BADGE = 'badge',
	DEFAULT = 'default',
	TEXT = 'text',
	FILE_NAME = 'fileName',
	KEY_VALUE = 'keyValueText',
	ACTION = 'action',
	CLASSIFICATION = 'classification',
	LOCATIONS = 'locations',
	DOCUMENT_TYPE = 'documentType',
	COST = 'cost',
	NS_COLUMN = 'nsColumn',
	LABELS = 'labels',
	CONDITION_GRADE = 'conditionGrade',
	REQUESTER = 'requester',
	TIMEFRAME = 'timeframe',
	DEVIATION_TYPE = 'deviationType',
}

export enum TABLE_ACTIONS {
	DELETE = 'DELETE',
	EDIT = 'EDIT',
	RELOAD = 'RELOAD',
	UNLINK = 'UNLINK',
}

export enum ACTION_TYPES {
	DELETE = 'DELETE',
	UNLINK = 'UNLINK',
	OPEN_IN_DT = 'OPEN_IN_DT',
}

export enum STATUS_TYPES {
	ACTIVE = 'ACTIVE',
	EXPIRED = 'EXPIRED',
	// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
	FAILED = 'EXPIRED',
	// eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
	CONNECTED = 'ACTIVE',
}
